import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ApiUrl from "../../config/app-config";

const baseURL = ApiUrl();

// 편집기 출력 태그 이름 + 경계 문자(공백·>·/)일 때만 HTML로 판별 ("<10% 할인>" 같은 텍스트 오판 방지)
// 편집기 출력은 태그 이름이 소문자라 대소문자를 구분 ("<A>코스" 같은 텍스트 오판 방지)
const HTML_TAG_PATTERN =
  /<\/?(p|div|br|span|table|figure|ul|ol|li|h[1-6]|strong|em|a|img|blockquote|pre|hr)(\s|>|\/)/;

const isHtmlContent = (content) => HTML_TAG_PATTERN.test(content || "");

const NoticeDetail = (props) => {
  /*header 영역*/
  /* api 받아오는 부분 */
  const [data, setData] = useState();
  const contentId = useParams();
  async function getData() {
    props.onIsLoading(true);
    try {
      //응답 성공
      const response = await axios.get(`${baseURL}/v1/notice`, {
        params: {
          id: contentId.id,
        },
      });
      const success = response.data;
      const result = success.result;
      props.onIsLoading(false);
      console.log(result[0]);
      setData(result[0]);
    } catch (error) {
      //응답 실패
      props.onIsLoading(false);
      props.onError(true);
      console.error(error);
    }
  }
  useEffect(() => {
    if (!data) {
      getData();
    }
  }, []);
  const pageName = "공지사항 상세";
  const headerUi = {
    goback: false,
    closeAll: true,
  };
  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);
  // const faqDetailData =
  //   data && data.filter((item) => String(item.id) === String(contentId.id));
  // const faqData = faqDetailData[0];
  // console.log(faqDetailData[0])

  return (
    <>
      {data ? (
        <div className="container notice_detail_wrap">
          <h3>{data.title}</h3>
          {isHtmlContent(data.content) ? (
            <div
              className="font-content notice_html"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          ) : (
            <p className="font-content">{data.content}</p>
          )}
        </div>
      ) : (
        <div>
          <h5>존재하지 않거나</h5>
          <h5>삭제된 공지입니다.</h5>
        </div>
      )}
    </>
  );
};
export default NoticeDetail;
